module.exports = __webpack_public_path__ + "static/media/FM_EU_Privacy_Policy_March_2025.168bd269.pdf";